import React from 'react';
import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';

const PaymentSuccessPage = () => {
    return (
        <div className="container mt-5">
            <Result
                status="success"
                title="Congratulations, you are now a Premium member!"
                subTitle="You can now take full advantage of our Premium features for our Matrimonial and Dating website."
                extra={
                    <Button type="primary">
                        <Link to="/dashboard">
                            <span className="text-white">Go to Dashboard</span>
                        </Link>
                    </Button>
                }
            />
        </div>
    );
};

export default PaymentSuccessPage;
